import { FC } from "react";
import { Session } from "@models/session";
import SessionRow from "@components/SessionsList/SessionRow";
import { useTranslation } from "react-i18next";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import StyledTableContainer from "@components/StyledTable";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { TablePagination } from "@mui/material";
import { PageResponse } from "@models/page-response";

export interface SessionListProps {
  sessions: PageResponse<Session>;
  onEdit?: (session: Session) => void;
  onRemove?: (index: number) => void;
  onSelect: (session: Session) => void;
  selectedSessions: Set<Session>;
  onPageChange: (e: any, page: number) => void;
  onRowsPerPageChange?: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
}

const SessionList: FC<SessionListProps> = ({
  sessions,
  onEdit,
  onRemove,
  onSelect,
  selectedSessions,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <StyledTableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableContainer.StyledTableCell />
              <StyledTableContainer.StyledTableCell>
                {t("sessions.list.type")}
              </StyledTableContainer.StyledTableCell>
              <StyledTableContainer.StyledTableCell>
                {t("sessions.list.date")}
              </StyledTableContainer.StyledTableCell>
              <StyledTableContainer.StyledTableCell>
                {t("sessions.list.duration")}
              </StyledTableContainer.StyledTableCell>
              <StyledTableContainer.StyledTableCell>
                {t("sessions.list.sentiment")}
              </StyledTableContainer.StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sessions?.data.map((session, index) => (
              <SessionRow
                selected={selectedSessions.has(session)}
                onSelect={() => onSelect(session)}
                onEdit={() => onEdit?.(session)}
                onRemove={() => onRemove?.(index)}
                session={session}
                key={session.id}
              />
            ))}
          </TableBody>
        </Table>
      </StyledTableContainer>
      <TablePagination
        component="div"
        count={sessions.meta.itemCount}
        page={sessions.meta.page - 1}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPage={sessions.meta.pageSize}
      />
    </>
  );
};

export default SessionList;
